import { MembersPage } from '@src/components/sco/Members/MembersLayout'
import { MembersMainPanel } from '@src/components/sco/Members/MembersLayout/MembersMainPanel'
import { UserProfile } from '@src/components/sco/Members/UserProfile'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { useParams } from 'next/navigation'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default MembersPage(function Page() {
  const params = useParams()

  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('members.single')
  })

  return (
    <MembersMainPanel>
      <UserProfile userSlug={`${params.memberSlug}`} />
    </MembersMainPanel>
  )
})
